import React, { useEffect, useState } from 'react'
import { intCol, strCol } from '@integec/grid-tools/lib/cols'

import {
  wind2AllPlant,
  wind2AllSubgroup,
  wind2SubgroupFormation,
  wind2SubgroupFormationDelete,
  wind2SubgroupFormationSave,
} from 'api/pgads.js'
import R from 'ramda'

import CommonScreen from 'admin/component/CommonScreen'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input, Select, message } from 'antd'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'

const Wind2SubgroupFormation = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [plantMap, setPlantMap] = useState({})
  const [subGroupMap, setSubGroupMap] = useState({})
  const [subgroupList, setSubgroupList] = useState([])

  useEffect(
    _ => {
      wind2AllPlant(apiTargetInfo).fork(
        _ => _,
        data => {
          const pm = R.reduce(
            (a, b) => ({ ...a, ...b }),
            {},
            data.map(d => ({ [d.plantId]: d.plantId + ' - ' + d.plantName }))
          )
          setPlantMap(pm)
        }
      )

      wind2AllSubgroup(apiTargetInfo).fork(
        _ => _,
        data => {
          const pm = R.reduce(
            (a, b) => ({ ...a, ...b }),
            {},
            data.map(d => ({
              [d.subgroupId]: d.subgroupName,
            }))
          )
          setSubGroupMap(pm)
          setSubgroupList(data)
        }
      )
    },
    [apiTargetInfo]
  )

  const handleAdd = (data, insertData, hide, onAdd) => _ => {
    if (
      data?.find(
        d =>
          d.plantId === insertData.plantId &&
          d.turbineId === insertData.turbineId
      )
    ) {
      message.error('Plant and Turbine pair must be unique.')
    } else {
      onAdd(hide)
    }
  }

  const insertComp = ({
    data,
    insertData = {},
    setInsertData,
    onAdd,
    onCancel,
  }) => {
    return (
      <div
        style={{
          display: 'grid',
          // gridTemplateColumns:
          //   '100px 250px 100px 250px 100px 250px 200px 200px ',
          gridTemplateColumns: '80px 250px 80px 250px 80px 250px 80px 250px',
          gap: 10,
          width: 1000,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>Plant :</Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Input
          value={insertData.plantId}
          onChange={e =>
            setInsertData({
              ...insertData,
              plantId: e.target.value,
            })
          }
        /> */}
        <Select
          style={{ width: '100%' }}
          value={insertData.plantId}
          data-cy="plant"
          onChange={val => setInsertData({ ...insertData, plantId: val })}
        >
          {R.compose(
            R.sortBy(R.prop('value')),
            R.map(([k, v]) => ({ id: k, value: v })),
            R.toPairs
          )(plantMap).map(k => (
            <Select.Option value={k.id} key={k.id} data-cy="plant">
              {/* {`${k}-${keymap[k]}`} */}
              {`${k.value}`}
            </Select.Option>
          ))}
        </Select>
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Subgroup :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Select
          style={{ width: '100%' }}
          value={insertData.subgroupId}
          data-cy="subgroup"
          onChange={val => setInsertData({ ...insertData, subgroupId: val })}
        >
          {R.compose(
            R.sortBy(R.prop('value')),
            R.map(([k, v]) => ({ id: k, value: v })),
            R.toPairs
          )(subGroupMap)
            .filter(
              e =>
                subgroupList.find(l => l.subgroupId === e.id)?.plantId ===
                insertData.plantId
            )
            .map(k => (
              <Select.Option value={k.id} key={k.id} data-cy="subgroup">
                {/* {`${k}-${keymap[k]}`} */}
                {`${k.value}`}
              </Select.Option>
            ))}
        </Select>
        {/* <Input
          value={insertData.subgroupId}
          onChange={e =>
            setInsertData({
              ...insertData,
              subgroupId: e.target.value,
            })
          }
        /> */}
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>Turbine :</Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Input
          value={insertData.turbineId}
          data-cy="turbine"
          onChange={e =>
            setInsertData({
              ...insertData,
              turbineId: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>Block :</Label>
        </div>
        <Input
          value={insertData.inverterBlock}
          placeholder="Block"
          onChange={e =>
            setInsertData({
              ...insertData,
              inverterBlock: e.target.value,
            })
          }
        />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: 10,
            gridColumnStart: '5',
            gridColumnEnd: 'span 2',
          }}
        >
          <Button
            type="primary"
            onClick={handleAdd(data, insertData, true, onAdd)}
          >
            Add
          </Button>
          <Button
            type="primary"
            onClick={handleAdd(data, insertData, false, onAdd)}
          >
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const Wind2SubgroupFormationHeaders = [
    strCol({
      ident: 'plantId',
      display: 'Plant',
      isKey: true,
      width: 250,
      sortOrder: 'asc',
      dataFormatter: ({ value }) => plantMap[value] || value,
      sortIndexGetter: ({ rowData }) =>
        plantMap[rowData.plantId] || rowData.plantId,
      ellipsis: true,
    }),
    intCol({
      ident: 'subgroupId',
      display: 'Subgroup',
      isKey: true,
      width: 350,
      sortOrder: 'asc',
      dataFormatter: ({ value }) =>
        subGroupMap[value] ? value + ' - ' + subGroupMap[value] : value,
      sortIndexGetter: ({ rowData }) =>
        subGroupMap[rowData.subgroupId] || rowData.subgroupId,
      ellipsis: true,
    }),
    strCol({
      ident: 'turbineId',
      display: 'Turbine',
      isKey: true,
      width: 250,
      sortOrder: 'asc',
      ellipsis: true,
    }),
    strCol({
      ident: 'inverterBlock',
      display: 'Block',
      width: 250,
      sortOrder: 'asc',
      ellipsis: true,
    }),
    modifierCol,
    modifiedDateCol,
  ]
  return (
    <CommonScreen
      title="Wind Subgroup Formation"
      header={Wind2SubgroupFormationHeaders}
      sortOptions={Wind2SubgroupFormationHeaders}
      saveTask={wind2SubgroupFormationSave}
      retrieveTask={wind2SubgroupFormation}
      deleteTask={wind2SubgroupFormationDelete}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      withImport
      importUrl="screen-csv-import-file"
      importData={{ importType: 'WIND_TURBINE_GROUP_FORMATION' }}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Wind2SubgroupFormation)
